import { render, staticRenderFns } from "./OnlineConsultationFee.vue?vue&type=template&id=212c0343&scoped=true"
import script from "./OnlineConsultationFee.vue?vue&type=script&lang=js"
export * from "./OnlineConsultationFee.vue?vue&type=script&lang=js"
import style0 from "./OnlineConsultationFee.vue?vue&type=style&index=0&id=212c0343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c0343",
  null
  
)

export default component.exports